import { createAction } from '@ngrx/store';

const loadProfessionalViews = createAction('[Professional List Store] Load professional views');
const loadTeams = createAction('[Professional List Store] Load teams');

export const ProfessionalListActions = {
  loadProfessionalViews,
  loadTeams,
};
